import { render, staticRenderFns } from "./AddNewNeighbor.vue?vue&type=template&id=f4352cb6&"
import script from "./AddNewNeighbor.vue?vue&type=script&lang=js&"
export * from "./AddNewNeighbor.vue?vue&type=script&lang=js&"
import style0 from "./AddNewNeighbor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports